import React, { Component } from 'react';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import { Loading } from '../../../../../../common/loading';
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel as Select  } from '../../../../../../common/custom-form/select-filter.component';
import { DATA_TYPE, MAX_LENGTH } from '../../../../../../../constants/external-constants';
import Translation from '../../../../../../common/translation/translation.component';
import CustomSearchableSelectWrapper from '../../../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Form } from 'react-redux-form';
import { actions } from "react-redux-form";
import { debitorCatalogueActions } from '../../../../../../../store/external/recharge-reducer/debitor-catalogue-reducer/debitor-catalogue.reducer';
import { convertToDecimal } from '../../../../../../../utils/helpers.utils';
import { VAT_GROUP } from '../../../../../../../constants/external-constants';
import { ORFSearchSuggestions as SearchSuggestions } from '../../../../../../common/forms/order-request-form.component';
import store from "../../../../../../../store";
import CustomSearchableDropdownWrapper from '../../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';

class DebitorDetailForm extends Component {
    constructor(props) {
        super(props);

        this.ConfirmationModal = React.createRef();

        this.state = {
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isLoading: true
        }
    }

    async componentDidMount(){
        const {debitorCatalogueForm, getSelectedSalesOrg, getDebitorSalesOrganizationList} = this.props
         let salesOrg = "";
            if(debitorCatalogueForm.salesOrganizationId){
                salesOrg =  await getSelectedSalesOrg(debitorCatalogueForm.salesOrganizationId);
            }

            getDebitorSalesOrganizationList(1, salesOrg).then(() =>{
                this.setState({isLoading: false})
            });

    }
    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];
    
        return translation[locale][key];
    }

    onChangeCountrySelection(e) {
        const { getCountryCode } = this.props;
        if (e != null) {
            getCountryCode(e);
        }
    }

    onChangeSalesOrgSelection(e) {
        const { getSalesOrganizationDetails } = this.props;
        if (e != null) {
            getSalesOrganizationDetails(e);
        }
    }

    checkVatGroupId(value){
        if(value == VAT_GROUP.Yes){
            return true;
        }
        else {
            return false;
        }
    }

    formatVatPercent = (vatGroupId, vatPercent) => {
        if (parseInt(vatGroupId) === 2 || parseInt(vatGroupId) === 0) {
            return convertToDecimal(0);
        }
        store.dispatch(actions.change('debitorCatalogueForm.vatPercent', vatPercent));

        return vatPercent;
    };

    disableVatPercent() {
        const { vatGroupId } = this.props.debitorCatalogueForm;
        return parseInt(vatGroupId) === 0 || parseInt(vatGroupId) === 2;
    }

    onChangeVatGroup(model, value) {

        const intValue = parseInt(value);

        store.dispatch(actions.change(model, value));
        store.dispatch(actions.change("debitorCatalogueForm.vatGroupId", intValue))
        this.props.setPercentExceed(false);
    }
     loadMoreCountries = (searchString) => {
        const { debitorCatalogue, getCountriesList } = this.props;
            getCountriesList(debitorCatalogue.countriesListPage + 1, searchString);
    }
     handleSearchCountries = (query) => {        
        const {getCountriesList} = this.props;
            getCountriesList(1, query);
    }

     loadMoreSalesOrganization = (searchString) => {
        const { debitorCatalogue, getDebitorSalesOrganizationList } = this.props;
            getDebitorSalesOrganizationList(debitorCatalogue.salesOrganizationPage + 1, searchString);
    }
     handleSearchSalesOrganization = (query) => {        
        const { getDebitorSalesOrganizationList } = this.props;
            getDebitorSalesOrganizationList(1, query);
    }

    render() {
        const { debitorCatalogue, debitorCatalogueForm, debitorAlreadyExist, percentExceed, isViewing } = this.props
        if (this.state.isLoading) {
            return <Loading />
        }

        return(
           <Form
                method="post"
                role = "form"
                model = "debitorCatalogueForm"
            >
                <div className="cost-allocation-form details-form-component">
                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={'debitor_number'} />}
                        value={debitorCatalogueForm.debitorNumber}
                        fieldProp='.debitorNumber'
                        placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                        maxLength={MAX_LENGTH.limit_20}
                        requiredField={true}
                        isError={debitorAlreadyExist}
                        disabled={isViewing ?? false}
                    />
                    
                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={'debitor_name'} />}
                        value={debitorCatalogueForm.debitorName}
                        fieldProp='.debitorName'
                        maxLength={MAX_LENGTH.limit_255}
                        placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                        requiredField={true}
                        disabled={isViewing ?? false}
                    />
                    
                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={'oe_name'} />}
                        value={debitorCatalogueForm.oeName}
                        fieldProp='.oeName'
                        maxLength={MAX_LENGTH.limit_255}
                        placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                        disabled={isViewing ?? false}

                    />           

                    <CustomSearchableDropdownWrapper
                        className="form-control"
                        label={<Translation translationKey={"country"} />}
                        options={debitorCatalogue.countryList}
                        selected={debitorCatalogueForm.countryId}
                        onChange={(e) => this.onChangeCountrySelection(e)}                  
                        fieldProp='.countryId'
                        tagName='key'
                        optionLabelKey={{
                            Key: 'Key',
                            Value: 'Value'
                        }}
                        maxLength={MAX_LENGTH.limit_100}
                        disabled={isViewing ?? false}
                        requiredField={true}
                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                        onSearchChange={this.handleSearchCountries}
                        onLoadMore={(val) => this.loadMoreCountries(val)}
                        isLoading={!this.props?.debitorCatalogue?.isDebitorCountryLoaded}
                        hasMore={debitorCatalogue?.hasMoreCountries}
                    />
                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={'country_code'} />}
                        value={debitorCatalogueForm.countryCode}
                        fieldProp='.countryCode'
                        maxLength={MAX_LENGTH.limit_10}
                        disabled={isViewing ?? true}
                        requiredField={true}   
                        isError={debitorAlreadyExist}
                    />
                   <Select
                        className="form-select required"
                        label={<Translation translationKey={"currency"} />}
                        options={debitorCatalogue.debitorCatalogueDropDownList.Currency}
                        value={debitorCatalogueForm.currencyId}
                        fieldProp='.currencyId'
                        maxLength={MAX_LENGTH.limit_10}
                        disabled={isViewing ?? false}
                        requiredField={true}
                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                    />
                    <CustomSearchableDropdownWrapper
                        className="form-control"
                        label={<Translation translationKey={"sales_organization_num"} />}
                        options={debitorCatalogue.salesOrganizationList}
                        selected={debitorCatalogueForm.salesOrganizationId}
                        onChange={(e) => this.onChangeSalesOrgSelection(e)}                  
                        fieldProp='.salesOrganizationId'
                        tagName='key'
                        optionLabelKey={{
                            Key: 'Key',
                            Value: 'Value'
                        }}
                        maxLength={MAX_LENGTH.limit_10}
                        disabled={isViewing ?? false}
                        requiredField={true}
                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                        isError={debitorAlreadyExist}
                        onSearchChange={this.handleSearchSalesOrganization}
                        onLoadMore={(val) => this.loadMoreSalesOrganization(val)}
                        isLoading={!this.props?.debitorCatalogue?.isDebitorSalesOrganizationListLoaded}
                        hasMore={debitorCatalogue?.hasMoreSalesOrgList}
                    />
                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={'sales_organization_name'} />}
                        value={debitorCatalogueForm.salesOrganizationName}
                        fieldProp='.salesOrganizationName'
                        maxLength={MAX_LENGTH.limit_255}
                        disabled={true}
                    />
                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={'sales_organization_country_code'} />}
                        value={debitorCatalogueForm.salesOrganizationCountryCode}
                        fieldProp='.salesOrganizationCountryCode'
                        maxLength={MAX_LENGTH.limit_10}
                        disabled={true}  
                    />
                    <Select
                        className="form-select required"
                        label={<Translation translationKey={'vat_group'} />}
                        options={debitorCatalogue.debitorCatalogueDropDownList.VatGroup}
                        value={debitorCatalogueForm.vatGroupId == 0 ? 2 : debitorCatalogueForm.vatGroupId}
                        onChangeAction={(e, v) => this.onChangeVatGroup(e, v)}
                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='.vatGroupId'
                        requiredField={true}
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                        isError={debitorAlreadyExist}
                        disabled={isViewing ?? false}
                    />  
                    <InputField
                        className="form-control"
                        type="text"
                        inputType={DATA_TYPE.decimal}
                        label={<Translation translationKey={'vat_applied'} />}
                        value={this.formatVatPercent(debitorCatalogueForm.vatGroupId, debitorCatalogueForm.vatPercent)}
                        fieldProp='debitorCatalogueForm.vatPercent'
                        placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                        requiredField={debitorCatalogueForm.vatGroupId == 0 ? true : this.checkVatGroupId(debitorCatalogueForm.vatGroupId)}
                        disabled={isViewing ?? this.disableVatPercent()}
                        isError={percentExceed}
                        hasDecimalLimit={true}
                        decimalFormat={[18,2]}
                    />
                </div>
            </Form>
        )
    }
}

export default withRouter(  
    connect(
        state => {
            const { translation, 
                    debitorCatalogue
                } = state;
            const { debitorCatalogueForm } = state.form;
            return {
                debitorCatalogueForm
                , debitorCatalogue
                , ...translation
            };
        },
        dispatch => ({
            ...bindActionCreators(Object.assign({}, debitorCatalogueActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
        })
    )(DebitorDetailForm)
);
